import React from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { useIsAuthenticated } from '../../Authentication/Hooks/AuthHooks';
import Unauthenticated from '../../Home/Unauthenticated';

export function PrivateRoute() {
    const isAuthenticated = useIsAuthenticated();

    return isAuthenticated ? <Outlet /> : <Unauthenticated/>;
}
